// extracted by mini-css-extract-plugin
export default {"layout":"auth-layout_layout__h94bs"};